export default "__VITE_ASSET__a0b96b41__"